import React from "react";
import { FaUser } from "react-icons/fa";

const Footer = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        zIndex: 100,
      }}
    >
      {/* Copyright text - centered */}
      <div
        style={{
          zIndex: 100,
          color: "white",
          textAlign: "center",
          marginRight: 320,
        }}
      >
        © 2023 - 2025, Powered by RescAlert Inc.
      </div>

      {/* Overwatch.ai button - positioned on right */}
      <div
        style={{
          padding: 10,
          height: 50,
          borderRadius: 100,
          background: "#436c9a",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          cursor: "pointer",
          position: "absolute",
          right: 0,
        }}
      >
        <div
          style={{
            background: "#0b1826",
            borderRadius: 100,
            padding: 5,
          }}
        >
          <FaUser style={{ color: "white" }} />
        </div>
        <div
          style={{
            marginTop: -3,
            marginRight: 5,
          }}
        >
          <a
            target="_blank"
            href="https://overwatch.ai"
            style={{
              color: "white",
              textDecoration: "none",
            }}
            rel="noreferrer"
          >
            overwatch.ai
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
